"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { AccountSessionMixins } from "@/service/account-session";
import AppHead from "./components/AppHead.vue";
import DateFormat from "@/framework/timeformatter";
import AuthorizationDialog from "./components/dialog/AuthorizationDialog.vue";
import { ApplicationDetailModel } from "@/models/Applications.model";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
let AppDetail = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.appID = "";
    this.appDetail = new ApplicationDetailModel();
    this.appLoading = false;
    this.btnLoading = false;
  }
  mounted() {
    return __async(this, null, function* () {
      this.appID = this.$route.query.id;
      if (this.appID) {
        this.getDetail(this.appID);
      }
    });
  }
  // async checkAccount(){
  //     try {
  //         const response = await API.get<OperationModel<boolean>>("api://base.apps.auth/v1/personal/apps/show");
  //         if(response.data.result !== true){
  //             // this.$message.error(this.$t('appdetail.you_do_not_have_permission_to_access_this_page_for_the_time_being_') as string)
  //             this.$router.push({ path: '/myapp' })
  //         }
  //         // console.log(response);
  //     } catch (error:any) {
  //         // console.log(error);
  //         if (error.hasOwnProperty('response')) {
  //             this.$message.error(error.response.data.errors.datas[0].message);
  //         }
  //     }
  // }
  addApp(app_id) {
    return __async(this, null, function* () {
      try {
        this.btnLoading = true;
        if (this.$session.type === "account") {
          const response = yield API.put(`api://base.apps.auth/v1/personal/apps/${app_id}`);
          this.$message.success(this.$t("appdetail.added_successfully"));
        }
        if (this.$session.type === "user") {
          UiConfirm.confirm(this.$t("appdetail.tip_content"), this.$t("appdetail.tip_title"));
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.btnLoading = false;
        this.getDetail(this.appID);
      }
    });
  }
  delApp(app_id) {
    return __async(this, null, function* () {
      try {
        this.btnLoading = true;
        const response = yield API.delete(`api://base.apps.auth/v1/personal/apps/${app_id}`);
        this.$message.success(this.$t("appdetail.uninstall_succeeded"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.btnLoading = false;
        this.getDetail(this.appID);
      }
    });
  }
  getDetail(id) {
    return __async(this, null, function* () {
      try {
        this.appLoading = true;
        const response = yield API.get(`api://base.apps.auth/v1/market/apps/${id}`);
        this.appDetail = response.data.result;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.appLoading = false;
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      this.getDetail(this.appID);
    });
  }
  timeFormat(time) {
    return DateFormat.dateformatterDay(DateFormat.check(time));
  }
  authorization() {
    this._uthorizationDialog.open(this.appID);
  }
  jump(url, isNew = false) {
    return __async(this, null, function* () {
      if (url === "" || url === null || url === void 0) {
        return;
      }
      if (isNew) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    });
  }
  tagType(color) {
    let _type = "";
    if (color === "green") {
      _type = "success";
    }
    if (color === "gray") {
      _type = "info";
    }
    if (color === "orange") {
      _type = "warning";
    }
    if (color === "red") {
      _type = "danger";
    }
    return _type;
  }
};
__decorateClass([
  Ref("authorizationDialog")
], AppDetail.prototype, "_uthorizationDialog", 2);
AppDetail = __decorateClass([
  Component({
    components: {
      AppHead,
      AuthorizationDialog,
      AccountSessionMixins
    }
  })
], AppDetail);
export {
  AppDetail as default
};
